<template>
    <div id="wrapper" >
      <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.dashboard.label.title')}}</h4>

                            </div>
                        </div>
                    </div>

                     <div class="row">
                       
                       <div class="col-lg-12">
                        <div class="card-box">
                            <h4 class="header-title mb-4">
                                <h4 class="page-title">
                                    {{$t('string.msg.dashboard.orders.fleet.driver.label.title')}}
                                </h4>
                            </h4>
                     
                            <div>
                                <b-tabs>

                                        <b-tab active>
                                            <template v-slot:title>
                                                <b-spinner type="grow" small></b-spinner> <strong>{{$t('string.msg.product.parts.label.title')}}</strong>
                                            </template>
                                            <ListOrdersParts />
                                        </b-tab>

                                        <b-tab>
                                            <template v-slot:title>
                                                <b-spinner type="grow" small></b-spinner> <strong>{{$t('string.msg.dashboard.services.tab')}}</strong>
                                            </template>
                                            <ListOrdersServices />
                                        </b-tab>
                                    
                                        <b-tab >
                                            <template v-slot:title>
                                                <b-spinner type="grow" small></b-spinner> <strong>{{$t('string.msg.dashboard.certifie.tab')}}</strong>
                                            </template>
                                            <ListOrdersCertifie />
                                        </b-tab>

                                </b-tabs>
                            </div>
                            
                        </div>
                        <!-- end card-box-->
                      </div>
                      <!-- end col -->
                     </div>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <ModalTerm v-on:confirmation-return="acceptedTermGeneral"/>
    </div>
</template>

<script>

import Controller from './CrtDashboard';
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';

import ModalTerm from '../../Modal/Term/ModalTerm';
import ListOrdersParts from './Orders/Parts/ListOrdersParts';
import ListOrdersServices from './Orders/Services/ListOrdersServices';
import ListOrdersCertifie from './Orders/Certifies/ListOrdersCertifie';


export default {
    name: 'Dashboard',
    components: {
    Spinner,
    Toast,
    ListOrdersParts,
    ListOrdersServices,
    ListOrdersCertifie,
    ModalTerm,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            orders: [],
            checkTerm: null,
            dataCompany:{},
            data: {
            },
            user: {
                serviceTypes: []
            }
        }
    },
    methods: Controller.methods,
    created() {
    },
    mounted() {
        Controller.init(this);
    }
    }
    </script>

    <style>
    </style>
